import React, { createContext, useContext, useState } from 'react';

const ExamContext = createContext();

export function ExamProvider({ children }) {
  // Exam config (subject, chapter, type, etc.)
  const [config, setConfig] = useState({});
  // Questions array
  const [questions, setQuestions] = useState([]);
  // Answers: { [questionIndex]: answer }
  const [answers, setAnswers] = useState({});
  // Marked for review: Set of question indices
  const [marked, setMarked] = useState(new Set());
  // Timer (seconds left)
  const [timer, setTimer] = useState(null);

  const value = {
    config, setConfig,
    questions, setQuestions,
    answers, setAnswers,
    marked, setMarked,
    timer, setTimer
  };

  return <ExamContext.Provider value={value}>{children}</ExamContext.Provider>;
}

export function useExam() {
  return useContext(ExamContext);
} 